import { digitGroup } from 'src/helpers'
import { formatCOANumber } from 'src/helpers/coa'
import generalModules from 'src/store/general'

export default function () {
  const { costType } = generalModules.state()
  return {
    visibleColumns: [
      'coa_id',
      'done_at',
      'name',
      'type',
      'value',
      'so_no',
      'po_no',
      'do_no'
    ],

    columns: [
      {
        name: 'coa_id',
        label: 'No. CoA',
        align: 'left',
        field: 'coa_id',
        format: (val) => {
          if (val) {
            return `<strong class="text-primary">${formatCOANumber(val)}</strong>`
          }
          return '-'
        }
      },
      {
        name: 'done_at',
        label: 'Tanggal',
        align: 'left',
        field: 'updated_at',
        commonDate: true,
        format: (val) => val || '-'
      },
      {
        name: 'name',
        field: 'name',
        label: 'Nama Detail',
        align: 'left',
        format: (val) => val || '-',
        rowClass: 'td-width-small'
      },
      {
        name: 'type',
        field: 'type',
        label: 'Jenis',
        align: 'left',
        format: (val) => {
          const cost = costType.find((c) => c.value === val)?.label
          if (cost) {
            const costClass = val === 'DEBIT' ? 'green' : 'red'
            return `<span class="custom-badge custom-badge-${costClass}">${cost}</span>`
          }
          return '-'
        }
      },
      {
        name: 'value',
        field: 'value',
        label: 'Nilai',
        align: 'left',
        format: (val) => `Rp${digitGroup(val)}` || '-'
      },
      {
        name: 'so_no',
        field: 'so_no',
        label: 'No. Sales Order',
        align: 'left',
        format: (val) => val || '-'
      },
      {
        name: 'po_no',
        field: 'po_no',
        label: 'No. Purchase Order',
        align: 'left',
        format: (val) => val || '-'
      },
      {
        name: 'do_no',
        field: 'do_no',
        label: 'No. Delivery Order',
        align: 'left',
        format: (val) => val || '-'
      }
    ]
  }
}
